export class ValidationMessages {
    public static ValueIsRequired: string = "Value cannot be empty";
}